import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigData } from "@calaosoft/osapp-common/config/models/ConfigData";
import { SqlDataSource } from "@calaosoft/osapp-common/sqlite/models/sql-data-source";
import { FlagService } from "../../../../services/flag.service";
import { SqlRemoteProvider } from "../../../sqlite/services/providers/sql-remote-provider.service";
import { CATALOG_DATABASE_ID } from "../catalog.constants";
import { ICatalogVersionResponse } from "../models/ICatalogVersionResponse";

@Injectable()
export class CatalogRemoteProviderService extends SqlRemoteProvider {
	//#region FIELDS

	protected override readonly C_LOG_ID = "CTLG.RMT.PRVDR.S::";

	//#endregion FIELDS

	//#region METHODS

	public constructor(poHttpClient: HttpClient, psvcFlag: FlagService) {
		super(poHttpClient, psvcFlag);
	}

	public override canProcess(psDatabaseId: string): boolean {
		return psDatabaseId === CATALOG_DATABASE_ID;
	}

	public override getLastUrl(psDatasourceId: string): string {
		return `${this.urlBase}last`;
	}

	public override getUrl(psDatabaseId: string, pnVersion: number): string {
		return `${this.urlBase}${pnVersion.toString()}`;
	}

	public override getLastDatabaseAsync(psDatabaseId: string): Promise<SqlDataSource> {
		return this.getRemoteLastVersionAsync(psDatabaseId).then(
			(poResult: ICatalogVersionResponse) => new SqlDataSource(psDatabaseId, +poResult.version, poResult.url)
		);
	}

	private getRemoteLastVersionAsync(psDatasourceId: string): Promise<ICatalogVersionResponse> {
		return this.getVersionResponseAsync<ICatalogVersionResponse>(psDatasourceId);
	}

	protected override createUrlBase(psWorkspace: string): string {
		return `${ConfigData.environment.cloud_url}/api/apps/${ConfigData.appInfo.appId}/workspaces/${psWorkspace}/entities/items/catalog/`;
	}

	//#endregion METHODS
}
